module.exports = __webpack_public_path__ + "static/img/14068B_2_C_20240605_LC.3b3acf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14068B_2_C_20240605_LC.png
// module id = cTGd
// module chunks = 0